// حالة وحسابات الاشتراك — لاعب بلا بيانات اشتراك يبقى "غير مسجل" ولا يُحسب ضمن أي حالة اشتراك أخرى
export const SUB_STATUS_LABELS = {
  active: 'فعال',
  pending_payment: 'بانتظار الدفع',
  upcoming: 'سيبدأ قريباً',
  paused: 'متوقف مؤقتاً',
  expired: 'منتهي',
  cancelled: 'ملغي',
};

export const PAYMENT_STATUS_LABELS = { paid: 'مدفوع', partial: 'مدفوع جزئياً', unpaid: 'غير مدفوع' };

const STATUS_STYLE = {
  active: 'bg-teal-50 text-teal-700',
  pending_payment: 'bg-amber-50 text-amber-700',
  upcoming: 'bg-blue-50 text-blue-700',
  paused: 'bg-slate-100 text-slate-500',
  expired: 'bg-red-50 text-red-600',
  cancelled: 'bg-slate-100 text-slate-400',
  not_registered: 'bg-slate-50 text-slate-400',
};

export const isSubscriptionRegistered = (p) => Boolean(p.subscription_status || p.subscription_start || p.subscription_end || p.subscription_amount);

export const riyadhTodayStr = () => new Date(Date.now() + 3 * 3600000).toISOString().slice(0, 10);

export const daysRemaining = (endDate) => {
  if (!endDate) return null;
  const end = new Date(`${String(endDate).slice(0, 10)}T00:00:00Z`);
  const today = new Date(`${riyadhTodayStr()}T00:00:00Z`);
  return Math.round((end - today) / 86400000);
};

// حالة فعلية للعرض: تعتمد على الحقل المخزّن، وإن غاب تُحسب من التاريخ لسجلات قديمة (بدون تعديل قاعدة البيانات)
export const effectiveStatus = (p) => {
  if (!isSubscriptionRegistered(p)) return 'not_registered';
  if (p.subscription_status) return p.subscription_status;
  const dl = daysRemaining(p.subscription_end);
  return dl !== null && dl < 0 ? 'expired' : 'active';
};

export const subscriptionBadge = (p) => {
  const status = effectiveStatus(p);
  return { key: status, label: status === 'not_registered' ? 'غير مسجل' : (SUB_STATUS_LABELS[status] || status), cls: STATUS_STYLE[status] || 'bg-slate-100 text-slate-500' };
};

// فلتر تنبيهي فقط — لا يغيّر الحالة المخزنة، ويشترط أن يكون الاشتراك فعالاً
export const isExpiringWithin = (p, days) => {
  if (effectiveStatus(p) !== 'active') return false;
  const dl = daysRemaining(p.subscription_end);
  return dl !== null && dl >= 0 && dl <= days;
};

export const progressBarColor = (p) => {
  const status = effectiveStatus(p);
  if (['paused', 'cancelled', 'not_registered', 'upcoming'].includes(status)) return 'bg-slate-300';
  const dl = daysRemaining(p.subscription_end);
  if (dl === null) return 'bg-slate-300';
  if (dl < 0) return 'bg-red-500';
  if (dl <= 7) return 'bg-red-500';
  if (dl <= 30) return 'bg-amber-500';
  return 'bg-teal-500';
};

export const progressBarPercent = (p) => {
  const status = effectiveStatus(p);
  if (status === 'expired') return 0;
  if (['paused', 'cancelled', 'not_registered', 'upcoming'].includes(status)) return 100;
  if (!p.subscription_start || !p.subscription_end) return 100;
  const start = new Date(String(p.subscription_start).slice(0, 10));
  const end = new Date(String(p.subscription_end).slice(0, 10));
  const today = new Date(riyadhTodayStr());
  const total = end - start;
  if (total <= 0) return 0;
  return Math.max(0, Math.min(100, ((end - today) / total) * 100));
};
